import { withSpinner } from '@frontend/state/spinner';
import { utility } from '@phi/components';
import { Flex } from '@phi/components/layout';
import { STRIPE_PRICING_TABLE, STRIPE_PRICING_TABLE_ONSHAPE, STRIPE_PUBLIC } from '@phi/config/frontend';
import { IFrontendServiceContainer } from '@phi/frontend/service-container';
import { CustomerSessionId } from '@phi/subscriptions/types';
import { load_script } from '@phi/util/dom';
import { set } from '@phi/util/vuetils';
import { Route } from '@phi/vue-router';
import { Option } from '@vaaas/fpts/option';
import { map } from '@vaaas/fpts/result';
import { PropType, defineComponent, h, onMounted, shallowRef } from 'vue';

export const SelectASubscription = defineComponent({
    props: {
        route: {
            required: true,
            type: Function as PropType<Route>,
        },

        app: {
            required: true,
            type: Object as PropType<IFrontendServiceContainer>,
        },
    },

    setup(props) {
        const { app } = props;
        const api = app.subscriptions.stripe.api;

        const loaded = shallowRef(false);
        const session = shallowRef<Option<CustomerSessionId>>(undefined);

        onMounted(withSpinner('Please wait...', () =>
            Promise.all([
                load_script('https://js.stripe.com/v3/pricing-table.js'),
                api.create_customer_session(['pricing-table']).then(map(set(session))),
            ]).then(() => loaded.value = true)
        ));

        //console.log("In select-a-subscription: App = ");
        //console.log(JSON.stringify(app.state));
        //console.log(JSON.stringify(app.state.framework));
        const pricing_table_id = app.state.framework == 'onshape' ? STRIPE_PRICING_TABLE_ONSHAPE : STRIPE_PRICING_TABLE;
        const header_str = app.state.framework == 'onshape' ? 'Thank you for trying out Phi!' : 'Click “Start Trial” to access Phi for 7 Days FREE';
        const subheader_str = app.state.framework == 'onshape' ? 'Subscribe to keep using Phi or <a href = "https://phi3d.com/contact" target = ”_blank”>contact us</a> for help.' : 'Select your Phi plan or <a href = "https://phi3d.com/contact" target = ”_blank”>contact us</a> for help.';
        //const pricing_table_id = app.state.framework == 'onshape' ? STRIPE_PRICING_TABLE : STRIPE_PRICING_TABLE;
        //console.log(pricing_table_id);


        return () =>
            loaded.value && h(Flex, {
                class: [
                    utility.entire_screen,
                    utility.p_2,
                    utility.overflow,
                ],
                align: 'center',
                direction: 'column',
                justify: 'center',
            }, () => [
                h('h2', {
                    style: { color: '#848484'}
                },
                header_str),

                h('p', {
                    innerHTML: subheader_str,
                    style: { color: '#848484'}
                }),

                /*
                h('h3', {
                    style: {
                        'color': '#000000',
                        'background-color': '#f7c12b',
                        'margin-top': '1.5rem',
                        'padding-top': '1.5rem',
                        'margin-bottom': '1.5rem',
                        'padding-bottom': '1.5rem',
                        'margin-left': '2.5rem',
                        'padding-left': '2.5rem',
                        'margin-right': '2.5rem',
                        'padding-right': '2.5rem',
                    },
                    // innerHTML: '<b>SPECIAL PROMO</b>: Apply promotion code <b>PROMO50</b> at checkout and get <b>50% discount</b> post trial!',
                }),
                */
                h('stripe-pricing-table', {
                    style: {
                        width: '100%',
                        'max-height': '50dvh',
                    },
                    'pricing-table-id': pricing_table_id,
                    'publishable-key': STRIPE_PUBLIC,
                    'customer-session-client-secret': session.value,
                }),
            ]);
    },
});
